import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { HandHelping } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { useSubscription, FEATURES } from '../../hooks/useSubscription';
import UpgradeModal from '../UpgradeModal';
import RequestProfessionalModal from '../Modals/RequestProfessionalModal';

const DEFAULT_CLASS = 'inline-flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r from-emerald-600 to-teal-600 text-white rounded-lg hover:from-emerald-700 hover:to-teal-700 font-semibold shadow-md transition-colors';

export const RequestProButton = ({
  label = 'Request a Professional',
  className = DEFAULT_CLASS,
  testId = 'request-pro-btn',
  initialSpecialty = '',
  initialCity = '',
  onSuccess,
}) => {
  const { user } = useAuth();
  const isAuthenticated = !!user;
  const { hasFeature, loading: subLoading, features } = useSubscription();
  const navigate = useNavigate();
  const [open, setOpen] = useState(null);
  const tierPending = isAuthenticated && (subLoading || !features);

  const handleClick = () => {
    if (!isAuthenticated) return navigate('/login');
    if (tierPending) return;
    setOpen(hasFeature(FEATURES.RESOURCES_PROFESSIONALS) ? 'request' : 'upgrade');
  };

  return (
    <>
      <button type="button" onClick={handleClick} disabled={tierPending} aria-busy={tierPending} className={`${className} disabled:opacity-60 disabled:cursor-wait`} data-testid={testId}>
        <HandHelping size={18} />
        <span>{label}</span>
      </button>
      <UpgradeModal
        isOpen={open === 'upgrade'}
        onClose={() => setOpen(null)}
        feature="resources_professionals"
        requiredTier="flourishing"
      />
      <RequestProfessionalModal
        isOpen={open === 'request'}
        onClose={() => setOpen(null)}
        onSuccess={onSuccess}
        initialSpecialty={initialSpecialty}
        initialCity={initialCity}
      />
    </>
  );
};
